import * as React from "react";
import 'shared/styles/bootstrap.scss';
import './TemplateListStyles.css';
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPTableSortDirectionEnum, WPTH} from "shared/controls/WPTable/WPTH";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {faFileImport} from "@fortawesome/free-solid-svg-icons/faFileImport";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {TemplateTypeDialog} from "./TemplateTypeDialog";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";

library.add(faPlus);
library.add(faFileImport);
declare let ajaxurl;
export class TemplateListApp extends React.Component<TemplateListProps, TemplateListState> {
    static defaultProps: Partial<TemplateListProps> = {};
    public file:HTMLInputElement;

    constructor(props: TemplateListProps) {
        super(props);
        this.state = {
            SortColumn:'',
            SortDirection:WPTableSortDirectionEnum.none,
            ImportIsBusy:false,
            ShowAdd:rednaoVarTemplateList.Text!=''
        };
    }

    public render() {

        return (
            <div style={{padding:10}} className={'rednao'}>
                {this.state.ShowAdd&&
                <div style={{padding:15,backgroundColor:'white',border:'1px solid #dfdfdf',borderRadius:20,marginBottom:10,display:"flex",alignItems:'center',position:'relative'}}>

                    <div style={{position: 'absolute', top: 10, right: 10}}>
                        <a href={'#'} onClick={e=>{e.preventDefault();this.NeverShowAgain()}}>Close and never show again </a>
                        <span style={{margin: '0 5px 0 5px'}}>|</span>
                        <a href={'#'} onClick={e=>{e.preventDefault();this.setState({ShowAdd:false})}}>Close</a>
                    </div>

                    <img src={rednaoVarTemplateList.Icon} style={{width:80,height:80}}/>
                    <div style={{marginLeft:10}}>
                        <p style={{fontSize:18,fontWeight:'bold',margin:0,marginRight:10}}>
                            {rednaoVarTemplateList.Text}
                        </p>
                        <a target={'_blank'} href={rednaoVarTemplateList.LinkURL}>{rednaoVarTemplateList.LinkText}</a>
                    </div>
                </div>
                }

                <h1>PDF Templates</h1>
                <input onChange={e=>this.FileSelected()} type={'file'} accept={'.zip'} ref={e=>this.file=e} style={{display:'none'}}/>
                <button onClick={e=>this.ActionSelected('edit',null)}  className={'rnbtn rnbtn-success'}><FontAwesomeIcon icon={"plus"}/>Add New</button>
                <SpinnerButton IsBusy={this.state.ImportIsBusy} Icon={'file-import'} OnClick={()=>this.file.click()} style={{marginLeft:5}} className={'rnbtn rnbtn-info'}>Import</SpinnerButton>
                <WPTable EmptyContent={
                    <div style={{padding:10,textAlign:'center'}}>

                        You haven't created any template yet!, <a onClick={e=>{e.preventDefault();this.ActionSelected('Edit',null)}} href={'#'}>Click here to create your first template</a>
                    </div>

                } Data={rednaoVarTemplateList.Templates} RowClicked={e=>this.ActionSelected('edit',e)} ActionClicked={(a,b)=>this.ActionSelected(a,b)}>
                    <WPBasicColumn PropertyName={'TemplateName'} Title={'Template Name'} IsSortable={true} IsClickable={true} IsPrimary={true}
                    Actions={[
                        {Title:'Edit',Id:'edit',ClassName:'edit'},
                        {Title:'Export',Id:'export',ClassName:'export'},
                        {Title:'Delete',Id:'delete',ClassName:'delete'}

                    ]}/>
                    <WPBasicColumn PropertyName={'FormName'} Title={'Form Name'} IsSortable={true}/>
                </WPTable>
            </div>


        )
    }

    public async ActionSelected(action:string, form:any)
    {

        if(action=='delete')
        {
            DeleteDialog.Show(form.TemplateName,"Are you sure?", ()=>{
                return new Promise<boolean>( async resolve => {
                    let result=await WpAjaxPost.Post('delete_template',{Id:form.Id});
                    if(result!=null)
                    {
                        let template=rednaoVarTemplateList.Templates.find(x=>x.Id==form.Id);
                        if(template!=null) {
                            rednaoVarTemplateList.Templates.splice(rednaoVarTemplateList.Templates.indexOf(template), 1);
                            this.forceUpdate();
                        }
                    }
                    resolve(result!=null);

                })

            });

            return;
        }

        if(action=='export')
        {
            window.location.href=ajaxurl+'?action='+rednaoVarTemplateList._prefix+'_export&template_id='+form.Id+'&_nonce='+rednaoVarTemplateList._nonce;
            return;
        }

        if(action=='edit') {
            let type='';

            let id = 0;
            if (form != null)
                id = form.Id;
            window.location.href = rednaoVarTemplateList.AdminUrl + '&template_id=' + id+(type=='pdf'?"&type=pdf":'');
        }
    }

    private async FileSelected() {
        if(this.file.files.length==0)
            return;

        this.setState({ImportIsBusy:true});
        let result=await WpAjaxPost.Post('import',{},null,{ImportFile:this.file.files[0]});

        this.file.value='';

        if(result!=null)
            this.ActionSelected('edit',{Id:result.TemplateId});
        else
            this.setState({ImportIsBusy:false});

    }


    private NeverShowAgain() {
        this.setState({ShowAdd:false});
        WpAjaxPost.Post('NeverShowAgain');
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateListProps {

}

interface TemplateListState {
    SortColumn:string;
    SortDirection:WPTableSortDirectionEnum;
    ImportIsBusy:boolean;
    ShowAdd:boolean;

}

//#endregion "My Region"